// project import
import adTools from './ad-tools';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [adTools]
};

export default menuItems;
